export const aiAgent = {
  head: {
    chip: "KI-Rezeption",
    listingLabel: "Inserat:",
  },
  globalNote: {
    title: "Kontoweite Einstellungen",
    body: "Gilt für <b>ALLE Ihre Unterkünfte</b>. Der KI-Agent betreut jede Person, die zum ersten Mal an Ihre <b>verbundene WhatsApp-Nummer</b> schreibt und <b>noch kein Kunde ist und keine Buchung hat</b>: Er beantwortet ihre Fragen und führt sie zur Buchung.",
  },
  perListingNote: {
    title: "Pro Inserat konfiguriert",
    body: "Die Rechnungsstellung nutzt den <b>Rechnungsaussteller</b>, der mit dem jeweiligen Inserat verknüpft ist, und wird daher in den Einstellungen jedes Inserats aktiviert und angepasst (nicht global). Öffnen Sie ein Inserat und gehen Sie zu «Rechnungsstellung».",
  },
  noEmisor: {
    title: "Dieses Inserat hat keinen Rechnungsaussteller",
    body: "Die Rechnungsstellung kann erst aktiviert werden, wenn Sie diesem Inserat unter <b>Mein Konto → Elektronische Rechnung</b> einen Aussteller zuordnen. Jeder Aussteller gehört zu genau einem Inserat.",
  },
  master: {
    requiresEmisor: "Erfordert einen Rechnungsaussteller",
    on: "An",
    off: "Aus",
  },
  cartelQr: {
    title: "Check-in-Poster für die Rezeption",
    hint: "Drucken Sie es aus und legen Sie es auf den Tresen: Der Gast scannt es, gibt seine Buchungsnummer ein und checkt vom Handy aus ein. Praktisch, wenn die OTA nicht alle Daten übermittelt.",
    steps: "Der Gast scannt · gibt seine Buchungsnummer ein · ergänzt seine Daten.",
    download: "Poster herunterladen (PDF)",
    downloading: "Wird vorbereitet…",
    downloadError: "Das Poster konnte nicht vorbereitet werden.",
    copy: "Link kopieren",
    copied: "Link kopiert",
    language: "Sprache des Posters",
    alsoEnglish: "Englisch darunter ergänzen",

    copyManual: "Kopieren nicht möglich. Markiere den Link und kopiere ihn von Hand.",
    popupBlocked: "Der Browser hat das Fenster blockiert. Kopiere den Link und öffne ihn in einem neuen Tab.",
    loadError: "Das Plakat konnte nicht geladen werden.",
    retry: "Erneut versuchen",  },
  checkinSchedule: {
    title: "Wann beginnt der Check-in?",
    hint: "Legen Sie fest, wann der Agent dem Gast den Check-in-Link sendet. Gilt auf Ebene des Inserats.",
  },
  avisoCheckin: {
    title: "E-Mail senden, wenn der Check-in fertig ist",
    hint: "Sobald die Gruppe die Registrierung abschließt, senden wir die Buchungsübersicht — Hauptgast, Begleiter und ihre Ausweise — mit dem unterschriebenen Meldeschein im Anhang. Praktisch für Pforte oder Rezeption.",
    enable: "Hinweis senden",
    steps: "Wird einmal gesendet, wenn sich die letzte Person der Gruppe registriert.",
    placeholder: "pforte@deineunterkunft.com",
    add: "E-Mail hinzufügen",
    remove: "Entfernen",
    max: "Höchstens {n} E-Mails.",
    save: "Speichern",
    saving: "Wird gespeichert…",
    saved: "Hinweis gespeichert",
    saveError: "Konnte nicht gespeichert werden.",
    badEmail: "„{email}“ ist keine gültige Adresse.",
    needOne: "Füge mindestens eine E-Mail hinzu, um den Hinweis zu aktivieren.",
  },
  field: {
    optional: "(optional)",
    yes: "Ja",
    no: "Nein",
  },
  variant: {
    nationality: "Nationalität",
    writingStyle: "Schreibstil",
  },
  robot: {
    title: "Was der Agent weiß",
  },
  pdf: {
    loaded: "Dokument hochgeladen · der Agent liest seinen Inhalt",
    remove: "Entfernen",
    replace: "PDF ersetzen",
    dropTitle: "Laden Sie eine PDF- oder Word-Datei mit dem Guide der Unterkunft hoch",
    dropHint: "PDF oder .docx · max. 15 MB",
  },
  payments: {
    required: "Erfordert die Verbindung einer Zahlungsplattform",
    connect: "Zahlungsplattform verbinden →",
  },
  faq: {
    qPlaceholder: "Frage · z. B. Gibt es Parkplätze?",
    aPlaceholder: "Antwort · z. B. Ja, kostenlos direkt vor der Tür.",
  },
  list: {
    remove: "Entfernen",
    add: "Hinzufügen",
  },
  footer: {
    saved: "Gespeichert",
    save: "Änderungen speichern",
  },
  wa: {
    online: "online",
    caption: "Vorschau · aktualisiert sich mit Ihren Einstellungen",
    defaultName: "KI-Rezeption",
  },
  errors: {
    pdfType: "Die Datei muss eine PDF- oder Word-Datei (.docx) sein.",
    pdfSize: "Die Datei überschreitet 15 MB.",
    pdfNoText: "Wir konnten keinen Text aus dem Dokument lesen (ist es eine gescannte oder leere PDF?). Versuchen Sie eine andere oder nutzen Sie den Freitext.",
    pdfUpload: "Die PDF konnte nicht hochgeladen werden.",
    pdfRemove: "Die PDF konnte nicht entfernt werden.",
    loadConfig: "Die Einstellungen konnten nicht geladen werden.",
    saveConfig: "Speichern nicht möglich. Bitte versuchen Sie es erneut.",
  },
  features: {
    general: {
      title: "Allgemeine Einstellungen",
      subtitle: "Legen Sie Identität und Stil des Agenten fest. Dies ist eine KONTO-Einstellung: Sie gilt für ALLE Ihre Unterkünfte.",
      sections: {
        identity: {
          label: "Identität des Agenten",
          hint: "Wie er sich vorstellt und in welchem Stil er antwortet.",
        },
      },
      fields: {
        agentName: {
          label: "Name des Agenten",
          placeholder: "z. B. Sofía, Rezeption Loft Ámbar…",
        },
        persona: {
          label: "Persönlichkeit",
          options: {
            amigable: "Freundlich und herzlich",
            profesional: "Professionell und findig",
            eficiente: "Direkt und effizient",
            entusiasta: "Begeistert und herzlich",
            sereno: "Ruhig und gelassen",
          },
        },
        tone: {
          label: "Tonfall der Antworten",
          options: {
            cercano: "Locker",
            cordial: "Herzlich",
            formal: "Förmlich",
            profesional: "Professionell",
          },
        },
        responseLength: {
          label: "Länge der Antworten",
          options: {
            brief: "Kurz (1-2 Sätze)",
            balanced: "Ausgewogen",
            detailed: "Ausführlich",
          },
        },
        useEmojis: {
          label: "Emojis verwenden",
        },
        language: {
          label: "Hauptsprache",
          options: {
            auto: "Automatisch (je nach Gast)",
            es: "Spanisch",
            en: "Englisch",
            fr: "Französisch",
            de: "Deutsch",
            pt: "Portugiesisch",
            it: "Italienisch",
          },
        },
        spanishVariant: {
          label: "Schreibstil (Spanisch)",
        },
        signature: {
          label: "Abschlusssignatur",
          placeholder: "z. B. Das Team von Loft Ámbar 🏡",
        },
      },
    },
    knowledge: {
      title: "Wissensdatenbank",
      subtitle: "Alles, was der KI-Agent wissen muss, um Ihre Gäste korrekt zu betreuen.",
      enableLabel: "Der Agent nutzt diese Wissensdatenbank",
      sections: {
        knowledge: {
          label: "Wissen zur Unterkunft",
          hint: "Wählen Sie, wie Sie die Informationen bereitstellen, die der Agent nutzt.",
        },
        behavior: {
          label: "Verhalten und Grenzen",
          hint: "Legen Sie die Regeln des Agenten fest und wann er menschliche Hilfe anfordert.",
        },
      },
      fields: {
        kbMode: {
          label: "Wie möchten Sie die Informationen bereitstellen?",
          options: {
            form: "Formulare",
            text: "Freitext",
            pdf: "Dokument hochladen",
          },
        },
        propertyType: {
          label: "Art der Unterkunft",
          options: {
            apartment: "Wohnung",
            house: "Haus",
            villa: "Villa",
            loft: "Loft",
            room: "Zimmer",
            cabin: "Hütte",
            hotel: "Hotel",
            hostel: "Hostel",
          },
        },
        kbText: {
          label: "Informationen zur Unterkunft",
          placeholder: "Schreiben oder fügen Sie hier ALLES ein, was der Agent wissen soll: WLAN und Passwort, Parken, Geräte, Heizung/Klimaanlage, Hausregeln, Tipps aus der Umgebung…",
          hint: "Der Agent nutzt diesen Text unverändert für seine Antworten.",
        },
        kbPdf: {
          label: "Dokument zur Unterkunft",
          hint: "Laden Sie den Guide der Unterkunft als PDF oder Word (.docx) hoch. Der Agent liest den Inhalt für seine Antworten.",
        },
        description: {
          label: "Allgemeine Informationen",
          placeholder: "Wie Heizung und Klimaanlage funktionieren, Geräte, Temperaturregelung, Besonderheiten der Unterkunft…",
          hint: "Wichtigster Kontext, den der Agent in jeder Antwort nutzt.",
        },
        wifiName: {
          label: "WLAN-Name",
          placeholder: "MeinWlan_5G",
        },
        wifiPassword: {
          label: "WLAN-Passwort",
        },
        parkingInfo: {
          label: "Parken",
          placeholder: "Kostenlos vor der Tür / Kostenpflichtig 100 m entfernt / Keine Parkplätze…",
        },
        amenities: {
          label: "Ausstattung und Geräte",
          placeholder: "Ausgestattete Küche, Waschmaschine, Trockner, Klimaanlage, Aufzug, Babybett, Handtücher…",
        },
        houseRules: {
          label: "Hausregeln",
          placeholder: "Nichtraucher, keine Partys, keine Haustiere, Ruhezeiten 22:00–08:00…",
        },
        localRecommendations: {
          label: "Tipps aus der Umgebung",
          placeholder: "Restaurants, Supermärkte, Verkehrsmittel, Sehenswertes in der Nähe…",
        },
        faqs: {
          label: "Häufige Fragen",
          hint: "Frage-Antwort-Paare. Sie können jedem Paar Bilder oder Videos anhängen.",
        },
        links: {
          label: "Links und Dokumente",
          itemPlaceholder: "https://… (Hausguide, Handbuch, Karte)",
          hint: "Externe Ressourcen, die der Agent nutzen kann.",
        },
        sendAmenityPhotos: {
          label: "Fotos der Ausstattung und Annehmlichkeiten senden",
          hint: "Fragt ein Gast nach einer Ausstattung, zu der es Fotos gibt, antwortet der Agent und schickt sie mit. Gibt es keine, antwortet er nur mit Text.",
        },
        customInstructions: {
          label: "Eigene Anweisungen",
          placeholder: "Bestimmte Regeln zu Tonfall oder Inhalt. Z. B. immer einen späten Check-out anbieten, wenn nach der Abreise gefragt wird.",
        },
        forbiddenTopics: {
          label: "Verbotene Themen oder Aktionen",
          placeholder: "Z. B. keine Rabatte geben, keine Terminänderungen ohne Freigabe bestätigen, keine Daten anderer Gäste weitergeben.",
        },
        escalationRules: {
          label: "Wann an einen Menschen übergeben wird",
          placeholder: "Z. B. bei einem Defekt, einer schweren Beschwerde oder einer Rückerstattungsanfrage an den Gastgeber übergeben.",
        },
        fallbackMessage: {
          label: "Nachricht, wenn er die Antwort nicht kennt",
          placeholder: "Das weiß ich gerade nicht genau, ich gebe es aber dem Gastgeber weiter und wir melden uns sofort 🙌",
        },
        humanContact: {
          label: "Kontakt des Gastgebers",
          placeholder: "+34 600 000 000",
        },
        supportHours: {
          label: "Zeiten für menschlichen Support",
          placeholder: "Mo–So 09:00–21:00",
        },
      },
    },
    checkin: {
      title: "Check-in",
      enableLabel: "Check-in automatisch verwalten",
    },
    newBookings: {
      title: "Neue Buchungen und Interessenten",
      subtitle: "Der Agent betreut neue Interessenten (Personen, die zum ersten Mal schreiben und buchen möchten oder Fragen haben) und sendet ihnen den Link für Direktbuchungen, damit sie die Buchung im Web abschließen. Dies ist eine KONTO-Einstellung: Sie gilt für alle Ihre Unterkünfte.",
      enableLabel: "Interessenten und Buchungsanfragen betreuen",
      sections: {
        businessIdentity: {
          label: "Identität des Unternehmens",
          hint: "Der Name, mit dem sich der Agent bei Personen vorstellt, die noch nicht gebucht haben.",
        },
        newLeads: {
          label: "Neue Interessenten · Erstkontakt",
          hint: "Wie er jemanden betreut, der zum ersten Mal schreibt, interessiert ist und noch nicht gebucht hat.",
        },
        bookingLink: {
          label: "Buchungslink",
        },
      },
      fields: {
        businessName: {
          label: "Name des Unternehmens",
          placeholder: "z. B. Hostel Elios, Apartamentos del Puerto, Grupo Ámbar…",
          hint: "Wenn jemand ohne Buchung fragt, wer Sie sind, antwortet der Agent «Ich bin der Assistent von [diesem Namen]». Wenn Sie das Feld leer lassen, stellt er sich allgemein vor, ohne das Unternehmen zu nennen.",
        },
        leadWelcomeMessage: {
          label: "Begrüßung für einen neuen Interessenten",
          placeholder: "Hallo! 👋 Ich bin der Assistent der Unterkunft. Suchen Sie Termine für eine Auszeit oder haben Sie Fragen? Ich helfe gern 😊",
          hint: "Begrüßung beim Erstkontakt, wenn jemand zum ersten Mal schreibt. Sie wird in späteren Nachrichten nicht wiederholt.",
        },
        leadWelcomeVerbatim: {
          label: "Begrüßung unverändert senden (ohne Anpassung)",
          hint: "An: Der Agent verwendet Ihre Nachricht beim Erstkontakt wortwörtlich. Aus: Er passt sie an den Ton des Gesprächs an.",
        },
        answerKbForLeads: {
          label: "Fragen auch vor der Buchung beantworten",
          hint: "Der Agent beantwortet allgemeine Fragen mit der Wissensdatenbank, auch wenn die Person noch kein Gast ist, und kann ihr zusätzlich den Buchungslink senden.",
        },
        proactiveOffer: {
          label: "Buchung aktiv vorschlagen",
          hint: "Auch wenn der Interessent nach anderem fragt, motiviert der Agent zur Buchung und sendet den Link, wenn es passt, ohne zu drängen.",
        },
        offerMessage: {
          label: "Nachricht beim Buchungsangebot",
          placeholder: "Sehr gern! Sie können direkt hier buchen 👇 Ich schicke Ihnen den Link, um Ihre Reisedaten zu wählen.",
          hint: "Der Ton, den der Agent beim Buchungsangebot verwendet. Den Link fügt der Agent automatisch hinzu.",
        },
      },
    },
    earlyAccess: {
      title: "Verwaltung der Ankunftszeit",
      subtitle: "Der Agent verwaltet Anfragen für einen frühen Check-in: Er erfasst die vom Gast gewünschte Ankunftszeit und behandelt sie nach Ihren Regeln.",
      enableLabel: "Ankunftszeiten verwalten",
      sections: {
        request: {
          label: "Bearbeitung der Anfrage",
          hint: "Wie der Agent je nach gewünschter Uhrzeit antwortet. Wenn Sie diese Optionen ausschalten, bleibt die Anfrage offen und Sie entscheiden (Bestätigen / Andere Uhrzeit bestätigen / Priorisieren / Ablehnen).",
        },
      },
      fields: {
        autoTentativeEarly: {
          label: "Mit «je nach Verfügbarkeit» antworten, wenn es vor dem Check-in liegt",
          hint: "Der Agent sagt dem Gast, dass Sie es versuchen; die Anfrage wartet auf Ihre Bestätigung.",
        },
        autoApproveLate: {
          label: "Automatisch bestätigen, wenn es nach dem Check-in liegt",
          hint: "Eine Ankunft innerhalb der normalen Zeiten wird von selbst bestätigt.",
        },
      },
    },
    lateCheckout: {
      title: "Später Check-out",
      subtitle: "Der Agent verwaltet Anfragen für einen späten Check-out: Er prüft die Uhrzeit, nennt den Preis und erfasst die Anfrage.",
      enableLabel: "Späten Check-out verwalten",
      sections: {
        availability: {
          label: "Verfügbarkeit und Uhrzeiten",
        },
        extraPrice: {
          label: "Preis pro Zusatzstunde",
          hint: "Berechnet wird nur der Teil nach den Kulanzstunden.",
        },
        messages: {
          label: "Nachrichten",
        },
      },
      fields: {
        standardCheckout: {
          label: "Normale Check-out-Zeit",
        },
        courtesyHours: {
          label: "Kulanzstunden (kostenlos)",
          unit: "h",
          hint: "Stunden nach dem normalen Check-out, die NIE berechnet werden.",
        },
        latestTime: {
          label: "Spätestmögliche Check-out-Zeit",
          hint: "Absolute Grenze. Nach der Kulanzzeit werden Zusatzstunden berechnet.",
        },
        subjectToAvailability: {
          label: "Je nach Verfügbarkeit",
          hint: "Zusatzstunden werden nur angeboten, wenn an diesem Tag keine andere Buchung anreist.",
        },
        autoConfirm: {
          label: "Automatisch bestätigen, wenn der Gast zusagt",
          hint: "Gilt nur für kostenlose Stunden.",
        },
        pricingModel: {
          label: "Preismodell",
          options: {
            fixed: "Festpreis",
            perHour: "Pro Zusatzstunde",
          },
        },
        price: {
          label: "Betrag",
          hint: "Festpreis oder Satz pro Zusatzstunde nach der Kulanzzeit.",
        },
        freeIfAvailable: {
          label: "Kostenlos, wenn am selben Tag niemand anreist",
          hint: "Ist der Tag frei, werden auch die Zusatzstunden nicht berechnet.",
        },
        paymentMethods: {
          label: "Zahlungsarten für die Zusatzstunden",
          options: {
            online: "Online-Zahlung (Stripe): Der Agent sendet einen Link",
            cash: "Bar beim Check-out",
          },
          hint: "Sie können eine oder beide anbieten. Der Agent informiert den Gast.",
        },
        offerMessage: {
          label: "Angebotsnachricht",
          placeholder: "Brauchen Sie mehr Zeit? Wir können den Check-out bis 13:00 anbieten.",
        },
        confirmationMessage: {
          label: "Bestätigungsnachricht",
          placeholder: "Erledigt! Ihr später Check-out ist bestätigt. Genießen Sie die Extrastunden 🙌",
        },
      },
    },
    invoicing: {
      title: "Rechnungsstellung",
      subtitle: "Der Agent sendet dem Gast einen Link, um seine Steuerdaten zu ergänzen und seine elektronische Rechnung herunterzuladen, und nutzt dafür den mit diesem Inserat verknüpften Rechnungsaussteller.",
      enableLabel: "Rechnungsanfragen verwalten",
      sections: {
        whenSend: {
          label: "Wann wird der Rechnungslink gesendet?",
          hint: "Wählen Sie, wie der Link den Gast erreicht. Die Optionen des gewählten Modus erscheinen darunter.",
        },
        requirements: {
          label: "Voraussetzungen für den sofortigen Versand",
          hint: "Der Agent übergibt den Link nur an Gäste, die den Check-in bereits abgeschlossen und die Buchung vollständig bezahlt haben; sobald sie ihre Daten eingeben, wird die Rechnung sofort erstellt und heruntergeladen. Bei OTA-Buchungen (Booking/Airbnb) kann die Rechnung erst nach Beginn der Leistung (Start des Aufenthalts) und vollständiger Zahlung ausgestellt werden.",
        },
        manualReview: {
          label: "Manuelle Prüfung",
          hint: "Es wird nur die Anfrage des Gastes erfasst und bleibt unter «Ausstehende Rechnungen» offen, damit Sie sie manuell ausstellen. Es wird keine Rechnung automatisch erzeugt, und es spielt keine Rolle, wann gefragt wird oder ob die Buchung bezahlt ist (Sie prüfen es).",
        },
        fiscalData: {
          label: "Steuerdaten des Ausstellers",
          hint: "Steuerdaten (Firmenname, Steuernummer, Serie, MwSt., Verifactu) werden hier NICHT konfiguriert: Sie stammen vom Rechnungsaussteller, der diesem Inserat unter Mein Konto → Elektronische Rechnung zugeordnet ist.",
        },
        sendToGuest: {
          label: "Versand an den Gast",
        },
      },
      modes: {
        after_checkout: {
          label: "Nur auf Anfrage",
          desc: "Der KI-Concierge antwortet, wenn der Gast nach seiner Rechnung fragt.",
        },
        always_after_checkout: {
          label: "Immer, wenn der Aufenthalt endet",
          desc: "An alle, die den Check-in abgeschlossen haben, ob sie fragen oder nicht. Empfohlen.",
        },
      },
      cards: {
        on_request: {
          label: "Sobald gefragt wird",
          desc: "Sie erhalten den Link sofort, wenn sie die Voraussetzungen erfüllen.",
        },
        after_checkout: {
          label: "Wenn der Aufenthalt endet",
          desc: "Die Anfrage wird gespeichert und der Link erreicht sie nach dem Check-out.",
        },
        manual: {
          label: "Nur erfassen",
          desc: "Sie bleibt offen und Sie stellen sie von Hand aus.",
        },
      },
      fields: {
        autoIssueIfNotSubmitted: {
          label: "Rechnung auch ausstellen, wenn das Formular nicht ausgefüllt wird",
          hint: "Sie wird mit den Check-in-Daten ausgestellt und die PDF per E-Mail und WhatsApp gesendet. Eine ausgestellte Rechnung kann nicht mehr bearbeitet werden.",
        },
        autoIssueAfterHours: {
          label: "Wie lange bis zur Ausstellung gewartet wird",
          options: {
            h24: "24 Stunden nach dem Senden des Links",
            h48: "48 Stunden nach dem Senden des Links",
            h72: "72 Stunden nach dem Senden des Links",
          },
        },
        manualSendLink: {
          label: "Dem Gast den Link zum Ergänzen der Steuerdaten senden",
          hint: "Wenn Sie es aktivieren, sendet der Agent den Link, damit der Gast seine Daten vorab angibt. Die Rechnung wird weiterhin manuell ausgestellt.",
        },
        sendToGuest: {
          label: "Link an den Gast senden per",
          options: {
            email: "E-Mail",
            whatsapp: "WhatsApp",
          },
        },
      },
    },
    extendStay: {
      title: "Aufenthalt verlängern",
      subtitle: "Der Agent verwaltet Anfragen für zusätzliche Nächte: Er prüft die Verfügbarkeit, nennt den Preis und erfasst die Anfrage.",
      enableLabel: "Anfragen zur Verlängerung des Aufenthalts zulassen",
      sections: {
        availability: {
          label: "Verfügbarkeit",
          hint: "Die maximale Anzahl an Nächten ergibt sich automatisch aus der nächsten Buchung im Kalender.",
        },
        price: {
          label: "Preis",
        },
        messages: {
          label: "Nachrichten",
        },
      },
      fields: {
        autoConfirm: {
          label: "Buchung bei Bestätigung automatisch verlängern",
          hint: "Wenn Sie das ausschalten, bleibt es eine Anfrage, die Sie freigeben.",
        },
        useListingRate: {
          label: "Nachtpreis des Inserats verwenden",
          hint: "Berechnet den Satz aus dem Buchungspreis.",
        },
        pricePerNight: {
          label: "Preis pro zusätzlicher Nacht",
          hint: "Nur wenn Sie nicht den Satz des Inserats verwenden.",
        },
        paymentMethods: {
          label: "Zahlungsarten für die zusätzlichen Nächte",
          options: {
            online: "Online-Zahlung (Stripe): Der Agent sendet einen Link",
            cash: "Bar",
          },
        },
        offerMessage: {
          label: "Angebotsnachricht",
          placeholder: "Möchten Sie länger bleiben? Ich kann Ihrer Buchung Nächte hinzufügen, je nach Verfügbarkeit.",
        },
        confirmationMessage: {
          label: "Bestätigungsnachricht",
          placeholder: "Super! Ich habe die zusätzlichen Nächte erfasst. Wir bestätigen, sobald die Zahlung abgeschlossen ist 🙌",
        },
      },
    },
  },
  preview: {
    common: {
      noCost: "ohne Aufpreis",
      subjectToAvailability: " Je nach Verfügbarkeit.",
    },
    default: "Hallo! Wie kann ich Ihnen helfen? 😊",
    knowledge: {
      guestWifi: "Wie lautet das WLAN-Passwort? 📶",
      wifiAnswer: "Gerne! Das WLAN-Netz heißt *{name}* und das Passwort ist *{pass}*. Viel Spaß! 😊",
      wifiNameFallback: "der Unterkunft",
      wifiPassFallback: "••••••",
      genericAnswer: "Natürlich! Ich schicke Ihnen sofort alle Informationen, die Sie zur Unterkunft brauchen 😊",
    },
    checkin: {
      propFallback: "Ihre Unterkunft",
      welcome: "🇩🇪 *Hallo* 👋 Ich bin 🤖 der virtuelle Assistent von *{prop}*.\nIch bin hier, um Ihnen beim Check-in zu helfen.\n\nDrücken Sie 'Ok', um mit dem Check-in fortzufahren.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{prop}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
      ok: "Ok",
      chooseLang: "Wählen Sie Ihre Sprache · Choose your language",
      langEs: "Deutsch",
      langEn: "English",
      linkMsg: "*Danke* 👋 Hier ist Ihr Link für den Check-in. 😎\n\n{link}",
    },
    newBookings: {
      offerDefault: "Sehr gern! 😊 Sie können direkt hier buchen. Ich schicke Ihnen den Link, um Ihre Reisedaten zu wählen:",
      whoAsk: "Mit wem spreche ich?",
      whoAnswer: "Hallo! Ich bin der Assistent von {biz} 😊 Wie kann ich helfen?",
      guestGreeting: "Hallo! Haben Sie an diesem Wochenende etwas frei? 😊",
      howBook: "Super, wie buche ich?",
      linkLine: "{offer}\n\n🔗 Hier buchen: {link}",
    },
    earlyAccess: {
      guestAsk: "Könnte ich früher einchecken? Ich komme gegen Mittag an 🙏",
      tentativeReply: "Wir haben Ihre frühe Ankunft um 12:00 notiert. Wir geben unser Bestes, damit alles bereit ist, das hängt aber vom Check-out der vorherigen Gäste und von der Reinigung ab. Wir melden uns, sobald es verfügbar ist 🙏",
      confirmedReply: "Wir haben Ihre frühe Ankunft um 12:00 erfasst. Wir bestätigen sie in Kürze 🙏",
    },
    lateCheckout: {
      courtesyPart: "Sie haben {hours} Stunden kostenlose Kulanzzeit nach {time}. ",
      costPart: "Ein Check-out bis {time} kostet {price}{perHour}.",
      perHourSuffix: " pro Zusatzstunde",
      payBoth: " Sie können online oder bar beim Check-out zahlen.",
      payCash: " Die Zahlung erfolgt bar beim Check-out.",
      guestAsk: "Kann ich morgen später auschecken? 😅",
      guestConfirm: "OK, ich bestätige 👍",
      cashExtra: " (oder bar beim Check-out)",
      confirmPayDefault: "Erledigt! Zum Bestätigen schließen Sie die Zahlung ab{extra}:",
      payLabel: "{price} zahlen",
      confirmCashDefault: "Erledigt! Ihr später Check-out ist bestätigt. Die Zahlung von {price} erfolgt bar beim Check-out. 😊",
    },
    invoicing: {
      guestAsk: "Können Sie mir die Rechnung schicken? 🧾",
      linkMsg: "Hallo! 👋\n\nHier ist Ihr Link, um Ihre elektronische Rechnung zu erstellen und herunterzuladen:\n{link}\n\nSie können diesen Link jederzeit wieder aufrufen.",
      thanks: "Danke für Ihren Aufenthalt! 🙌 Wenn Sie Ihre Rechnung brauchen, hier ist der Link 👇",
      autoIssueNote: "_({hours} Std. später, falls die Daten nicht ergänzt wurden)_\n\nWir haben Ihre Rechnung mit Ihren Check-in-Daten ausgestellt und Ihnen per E-Mail geschickt. 📩",
      manualLinkMsg: "Hallo! 👋\n\nHier ist der Link, um Ihre Steuerdaten zu ergänzen:\n{link}\n\nWir prüfen Ihre Anfrage und stellen die Rechnung manuell aus. 😊",
      manualRegistered: "Hallo! 👋 Ich habe Ihre Rechnungsanfrage erfasst. Wir prüfen sie und stellen die Rechnung so bald wie möglich manuell aus. Danke! 😊",
    },
    extendStay: {
      guestAsk: "Kann ich eine Nacht länger bleiben? 🌙",
      guestConfirm: "Ja, eine Nacht mehr 👍",
      rateListing: "zum Preis Ihrer Buchung",
      ratePerNight: "für {price}/Nacht",
      nightSingular: "Nacht",
      nightPlural: "Nächte",
      offerDefault: "Klar! Ich kann bis zu {max} {nights} {rate} hinzufügen.{avail}",
      cashExtra: " (oder bar)",
      confirmPayDefault: "Perfekt! Zum Bestätigen der zusätzlichen Nacht schließen Sie die Zahlung ab{extra}:",
      payLabel: "Zusätzliche Nacht zahlen",
      confirmCashDefault: "Perfekt! Ich habe die zusätzliche Nacht erfasst. Die Zahlung erfolgt bar und der Gastgeber bestätigt die Verlängerung. 😊",
    },
    general: {
      guestAsk: "Hallo! Mit wem spreche ich?",
      whoWithName: "Ich bin {name}, Ihr",
      whoNoName: "Ich bin Ihr",
      answer: "Hallo! {who} Empfangsassistent. Wie kann ich Ihnen helfen?{emo}",
    },
  },
  nationalities: {
    auto: "Automatisch (je nach Gast)",
    latam: "Lateinamerika (neutral)",
    countries: {
      ES: "Spanien",
      MX: "Mexiko",
      CO: "Kolumbien",
      AR: "Argentinien",
      CL: "Chile",
      PE: "Peru",
      VE: "Venezuela",
      EC: "Ecuador",
      UY: "Uruguay",
      PY: "Paraguay",
      BO: "Bolivien",
      CR: "Costa Rica",
      PA: "Panama",
      GT: "Guatemala",
      DO: "Dominik. Rep.",
      PR: "Puerto Rico",
      CU: "Kuba",
      FR: "Frankreich",
      PT: "Portugal",
      BR: "Brasilien",
      US: "Vereinigte Staaten",
      IT: "Italien",
      BE: "Belgien",
      MA: "Marokko",
      NL: "Niederlande",
      CH: "Schweiz",
    },
    styles: {
      latamNeutral: "Neutrales Lateinamerikanisch",
      esES: "Standard: informell (tú) · «vale», «genial»",
      esMX: "Standard: «con gusto», «estacionamiento»",
      esCO: "Allgemein: förmlich (usted) · «con gusto»",
      esCOpaisa: "Paisa (Medellín): «pues», «hágale»",
      esCOcosta: "Küste (Karibik): «¡ajá!», «quihubo»",
      esCOrolo: "Rolo (Bogotá): förmlich (usted) · «a la orden»",
      esCOvalle: "Valluno (Cali): voseo · «vea pues»",
      esCOsantander: "Santander: direkt · «de una»",
      esAR: "Voseo: «dale», «buenísimo»",
      esCL: "Herzlich: «estacionamiento»",
      esPE: "Förmlich (usted): neutrales Andenspanisch",
      esVE: "Informell (tú): «chévere»",
      esEC: "Förmlich (usted): neutrales Andenspanisch",
      esUY: "Voseo: «ta», «bo»",
      esPY: "Voseo: herzlich",
      esBO: "Förmlich (usted): andin",
      esCR: "Voseo: «pura vida»",
      esPA: "Informell (tú): karibisch",
      esGT: "Förmlich (usted): herzlich",
      esDO: "Informell (tú): karibisch",
      esPR: "Informell (tú): karibisch",
      esCU: "Informell (tú): karibisch",
      frFR: "Französisch (Frankreich)",
      ptPT: "Portugiesisch (Portugal)",
      ptBR: "Portugiesisch (Brasilien)",
      enUS: "Amerikanisches Englisch",
      itIT: "Italienisch (Italien)",
      frBE: "Französisch (Belgien)",
      nlBE: "Niederländisch / Flämisch (Belgien)",
      arMA: "Arabisch (Marokko)",
      frMA: "Französisch (Marokko)",
      nlNL: "Niederländisch",
      deCH: "Schweizerdeutsch",
      frCH: "Schweizer Französisch",
      itCH: "Schweizer Italienisch",
    },
  },
};
